import Modal from "../Modal";
import OutlineButton from "../OutlineButton";
import React from "react";
import styles from "./ComboSubstitutionModal.module.css";
import TextButton from "../TextButton";
import {API, Lib} from "habit-core";
import {useAppSelector} from "../../lib/hooks";

const strings = {
    title: "Select Desired Combo",
};

type Props = {
    combos: API.models.Combo[];
    replacedEntreeItem: Lib.selectors.ComboItem;
    onClickCombo: (categoryId: string, comboId: string) => void;
    onClose: () => void;
};

export function ComboSubstitutionsModal({
    combos,
    replacedEntreeItem,
    onClickCombo,
    onClose,
}: Props) {
    const menuId = useAppSelector((state) => state.currentOrder.menuId ?? "");
    const combosById = useAppSelector((state) => state.combos.byId);
    const menuCombosByMenuId = useAppSelector(
        (state) => state.menuCombos.byMenuId,
    );
    const menuItemsByMenuId = useAppSelector(
        (state) => state.menuItems.byMenuId,
    );
    const menuItemModifiersByMenuId = useAppSelector(
        (state) => state.menuItemModifiers.byMenuId,
    );

    const getComboPriceCents = (combo: API.models.Combo) => {
        const items: Lib.selectors.ComboItem[] = [
            replacedEntreeItem,
            ...combo.itemIds
                .slice(1)
                .map((itemId) => ({itemId: itemId, modifierSelections: {}})),
        ];
        return Lib.selectors.getComboUnitPriceCents(
            combo.id,
            menuId,
            items,
            menuItemsByMenuId,
            menuItemModifiersByMenuId,
            menuCombosByMenuId,
            combosById,
            false,
        );
    };

    return (
        <Modal className={styles.modalContainer} onClose={onClose}>
            <div className={styles.title}>{strings.title}</div>
            <div className={styles.combosContainer}>
                {combos.map((c, i) => (
                    <OutlineButton
                        key={i}
                        className={styles.comboButton}
                        label={c.name}
                        label2={Lib.currency.centsToDollarString(
                            getComboPriceCents(c),
                        )}
                        mode="blue"
                        onClick={() => {
                            onClickCombo(c.categoryIds[0], c.id);
                        }}
                    />
                ))}
            </div>
            <TextButton label="Cancel" onClick={onClose} />
        </Modal>
    );
}
